// The task card's "Reminder sent …" line, from the `lastReminder` the planning list returns.
// Standalone (not in the utils barrel) so vitest can import it — see frontend/CLAUDE.md.

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

// `sentAt` is a LocalDateTime from the server (no zone), which `new Date()` reads as local time —
// right for a server and browser in the same zone, and off by the offset otherwise. Acceptable for a
// "sent today / 3 Oct" label; not something to compute durations from.
export function reminderSentLabel(lastReminder, currentUserEmail, now = new Date()) {
  if (!lastReminder?.sentAt) return "";
  const sentAt = new Date(lastReminder.sentAt);
  if (Number.isNaN(sentAt.getTime())) return "";

  const when = sameDay(sentAt, now)
    ? `today, ${sentAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
    : sentAt.toLocaleDateString([], {
      day: "numeric",
      month: "short",
      ...(sentAt.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }),
    });

  const byMe =
    !!currentUserEmail &&
    !!lastReminder.sentByEmail &&
    lastReminder.sentByEmail.toLowerCase() === currentUserEmail.toLowerCase();
  const who = byMe ? "you" : lastReminder.sentByName || lastReminder.sentByEmail;

  return `Reminder sent ${when}${who ? ` by ${who}` : ""}`;
}
